export const MIN_CREDITS_TO_SEND_MESSAGE = 1;
